//---------------------------- Device Constanst ------------------------------------------//
import { isMobileOnly } from 'react-device-detect';
export const mobile = window.innerWidth < 760 || isMobileOnly ? true : false;

//---------------------------- Date Constanst ------------------------------------------//

export const largeDate = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true
};

export const largeDatess = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: true
};

export const largeDate24 = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false
};

export const smallDate = {
  year: 'numeric',
  month: 'short',
  day: 'numeric'
};

export const smallDatev1 = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric'
};

export const monthYear = {
  year: 'numeric',
  month: 'short'
};

export const hourMinute = {
  hour: 'numeric',
  minute: 'numeric'
  //second: "numeric",
};

export const hourMinuteSecond = {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
};

//---------------------------- Color Constanst ------------------------------------------//

export const category10 = [
  '1f77b4',
  'ff7f0e',
  '2ca02c',
  'd62728',
  '9467bd',
  '8c564b',
  'e377c2',
  '7f7f7f',
  'bcbd22',
  '17becf'
];

export const accent = [
  '7fc97f',
  'beaed4',
  'fdc086',
  'ffff99',
  '386cb0',
  'f0027f',
  'bf5b17',
  '666666'
];

export const dark2 = [
  '1b9e77',
  'd95f02',
  '7570b3',
  'e7298a',
  '66a61e',
  'e6ab02',
  'a6761d',
  '666666'
];

export const paired = [
  'a6cee3',
  '1f78b4',
  'b2df8a',
  '33a02c',
  'fb9a99',
  'e31a1c',
  'fdbf6f',
  'ff7f00',
  'cab2d6',
  '6a3d9a',
  'ffff99',
  'b15928'
];

export const set1 = [
  'e41a1c',
  '377eb8',
  '4daf4a',
  '984ea3',
  'ff7f00',
  'ffff33',
  'a65628',
  'f781bf',
  '999999'
];

export const set2 = [
  '66c2a5',
  'fc8d62',
  '8da0cb',
  'e78ac3',
  'a6d854',
  'ffd92f',
  'e5c494',
  'b3b3b3'
];

export const accenture = [
  // 'a100ff',
  '7500c0',
  '460073',
  'b455aa',
  'a055f5',
  'be82ff',
  'dcafff',
  'e6dcff'
];

export const secondary = [
  '0041f0',
  '00ffff',
  '64ff50',
  '05f0a5',
  'ff3246',
  'ff50a0',
  'ff7800',
  'ffeb32'
];

export const palatte1 = ['610C9F', 'DA0C81', '363062', '4D4C7D', 'F99417', 'FFCD4B'];

//contains >55 colors
export const custom1 = [
  ...palatte1,
  ...accenture,
  ...category10,
  ...dark2,
  ...paired,
  ...set1,
  ...set2,
  ...accent,
  ...secondary
];
